// extracted by mini-css-extract-plugin
module.exports = {"FiltersLegendWrapper":"AllocationsCalendarContainer_FiltersLegendWrapper__3xUoJ"};